import React, { ReactElement } from 'react'; // useState
import AdminTemplate from 'components/templates/AdminTemplate';
import { Grid, Typography } from '@material-ui/core'; // Button, TextField, CircularProgress
// import { useRefundContext } from 'contextApi/RefundContext';
// import useStyles from './Refund.styles';
// import payImg from 'assets/img/undraw_pay_online_b1hk.svg';
// import MuiAlert from '@material-ui/lab/Alert';
// import RefundModal from 'components/organisms/RefundModal';

export default function Refund(): ReactElement {
  // const classes = useStyles();

  // const [validateRefund, setValidateRefund] = useState({
  //   haveErrors: false,
  //   errorMessage: ''
  // });
  // const { setOrder, setOrderNumber, orderNumber } = useRefundContext();
  // const [isLoading, setIsLoading] = useState(false);
  // const [openModal, setOpenModal] = useState<boolean>(false);

  // const Alert = (props: any) => {
  //   return <MuiAlert elevation={6} variant="filled" {...props} />;
  // };

  // const handleSubmit = (e: React.FormEvent) => {
  //   e.preventDefault();
  //   /* if (!orderNumber) {
  //     setValidateRefund({
  //       haveErrors: true,
  //       errorMessage: 'Este campo es obligatorio'
  //     });
  //     return;
  //   } */
  //   // handleGetOrderByNumber(orderNumber);
  //   setOpenModal(true); // Cuando ya termine de hacer la petición
  // };

  // const handleCloseModalEdit = () => {
  //   setOpenModal(false);
  //   console.log('prueba');
  // };

  return (
    <AdminTemplate>
      <React.Fragment>
        <Grid container justify="center" style={{ marginTop: 20 }}>
          <Typography variant="h5" component="h1" align="center">
            Reembolsos
          </Typography>
        </Grid>
        {/* <Grid container justify="center" alignItems="center" className={classes.marginContainer}>
          <Grid container justify="center" alignItems="center">
            <img src={payImg} height="300" width="300"></img>
          </Grid>
          <Grid container justify="center" alignItems="center">
            <form onSubmit={handleSubmit}>
              <Grid item xs={12} sm={12} md={12}>
                <TextField
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  label="Número de Orden"
                  name="document"
                  onChange={(e) => {}}
                  autoFocus
                  disabled={isLoading}
                  error={validateRefund.haveErrors}
                  helperText={validateRefund.errorMessage}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>

              <Grid container justify="center">
                <Button
                  disabled={isLoading}
                  type="submit"
                  variant="contained"
                  color="primary"
                  className={classes.marginButtom}
                >
                  {isLoading ? <CircularProgress size={24} /> : ''} Enviar
                </Button>
              </Grid>
            </form>
          </Grid>
        </Grid>
        <RefundModal openModal={openModal} closeModal={handleCloseModalEdit} /> */}
      </React.Fragment>
    </AdminTemplate>
  );
}
